import { decodeToken, getToken } from "@client/utils";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { noop } from "@client/shared/constants";
import Typography from "@mui/material/Typography";
import Skeleton from '@mui/material/Skeleton';
import Alert from '@mui/material/Alert';
import Button from "@mui/material/Button";
import { validate as validator } from '@client/utils';
import { VALIDATIONS } from '@client/shared/constants';




const RingoutPrerecorderView = ({
  extension = null,
  extensionPhoneNumber = null,
  announmentOnlyList = [],
  phoneNumberList = [],
  phoneNumber = null,
  greeting = {},
  loaders = {},
  countryList = [],
  phoneNumberError = " ",
  handleRingoutChange = noop,
  openRecorderDialog = noop,
}) => {

  const getAudioUrl = (greeting) => {
    const token = decodeToken(getToken());
    let url = greeting?.contentUri || "";;
    return url ? `${url}?access_token=${token?.rc_access_token}` : '';
  };

  return (
    <Box>
      <Box>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Use this announcement only extension:</Typography>
        <Autocomplete
          fullWidth
          blurOnSelect
          label="AnnouncementOnly"
          size="small"
          getOptionLabel={option => {
            return `${option.name || ""}${option.extensionNumber ? ` (Ext. ${option.extensionNumber})` : ""}`
          }}
          
          value={extension}
          options={announmentOnlyList}
          onChange={(_, value) => {
            handleRingoutChange('extension', value);
            handleRingoutChange('extensionPhoneNumber', null);
          }}
          renderInput={(params) => (
            <>
              {loaders.announmentOnlyList ? (
                <Skeleton width="100%" height={64} />
              ): (
                <TextField
                  size="small"
                  placeholder="Type or select Announcement Only Extension from the dropdown"
                  {...params}
                />
              )}
            </>
          )}
        />
      </Box>
      {loaders.phoneNumberList && (
        <Box sx={{ display: 'flex' }}>
          <Skeleton width="45%" height={64} sx={{ mr: 2 }} />
          <Skeleton width="45%" height={64} sx={{ mx: 2 }} />
          <Skeleton width="10%" height={64} sx={{ ml: 2 }} />
        </Box>
      )}
      {(!loaders.phoneNumberList && extension && !!phoneNumberList.length) && (
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ width: "50%", mr: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Use this associated number</Typography>
            <Autocomplete
              fullWidth
              blurOnSelect
              label="Phone Number"
              size="small"
              getOptionLabel={option => option.phoneNumber || ""}
              value={extensionPhoneNumber}
              options={phoneNumberList}
              onChange={(_, value) => handleRingoutChange('extensionPhoneNumber', value)}
              renderInput={(params) => (
                <>
                  {loaders.phoneNumberList ? (
                    <Skeleton width="100%" height={64} />
                  ): (
                    <TextField
                      size="small"
                      placeholder="Type or select Phone Number from the dropdown"
                      {...params}
                    />
                  )}
                </>
              )}
            />
          </Box>
          <Box sx={{ width: "50%", ml: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Greeting</Typography>
            {loaders.greeting ? (
              <Skeleton width="100%" height={64} />
            ): (
              <Box sx={{ display: "flex", alignItems: 'center' }}>
                {greeting ? (
                  <audio style={{ width: "100%", height: "36px"}} controls src={getAudioUrl(greeting)}></audio>
                ): (
                  <Typography color="error" variant="body2">Greeting not found.</Typography>
                )}
                <Button onClick={openRecorderDialog} sx={{ ml: 2 }} size="small" variant="outlined">Change</Button>
              </Box>
            )}
          </Box>
        </Box>
      )}
      {(extension?.id && !loaders.phoneNumberList) && (
        <Box sx={{ mt: 4 }}>
          {!!phoneNumberList.length ? (
            <>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>Notify this number</Typography>
              <TextField
                size="small"
                label="Type phone number"
                value={phoneNumber}
                error={!!(phoneNumberError || "").trim()}
                helperText={phoneNumberError}
                onChange={evt => {
                  const value = evt?.currentTarget?.value;
                  const validateResult = validator(value, VALIDATIONS.PHONE, countryList);
                  const errorMessage = validateResult.errorMessage || " ";
                  handleRingoutChange('phoneNumber', value);
                  handleRingoutChange('phoneNumberError', errorMessage);
                }}
              />
            </>
          ): (
            <Alert severity="error">
              No phone number is associated with the selected extension. Please assign at least one number to the extension via service web.
            </Alert>
          )}
        </Box>
      )}
    </Box>
  );
};

export default RingoutPrerecorderView;